









































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { StreamBarcodeReader } from 'vue-barcode-reader';

@Component({
  components: {
    StreamBarcodeReader,
  },
})
export default class BarcodeScanner extends Vue {
  @Prop({ default: false }) private value!: boolean;
  private showDialog: boolean = false;
  private barcodeLoaded: boolean = false;
  private makePersistent: boolean = false;
  private errorTimeoutHandle: any;

  @Watch('value', {immediate: true})
  private onValueChanged(val: boolean) {
    this.showDialog = val;
  }

  @Watch('showDialog')
  private onShowDialogChanged(val: boolean) {
    clearTimeout(this.errorTimeoutHandle);
    if (!val) {
      this.barcodeLoaded = false;
    } else {
      this.errorTimeoutHandle = setTimeout(() => {
        alert('Camera timeout, please make sure you have allowed camera access to the application');
        this.showDialog = false;
      }, 10000);
    }
    this.$emit('input', val);
  }

  private onReaderLoaded() {
    clearTimeout(this.errorTimeoutHandle);
    this.barcodeLoaded = true;
  }

  private onReaderDecode(v1: any, v2: any, v3: any) {
    this.$emit('scanned', {v1, v2, v3});
    if (this.makePersistent) {
      return;
    }
    this.showDialog = false;
  }

  private onReaderError(err: any) {
    alert(err);
    this.showDialog = false;
  }

}
